import { HttpResponseStatusCodes } from '@hobt/constants';

/**
 * Error Codes that are used when throwing new HBT Errors.
 * Each code object consists of a
 *
 * Note: Do not use httpCode: 408, it can cause the lambda to infinite loop
 */

export const HbtServiceErrorCodes: { [key: string]: any } = {
  /**
   * HBT Error Codes - Portfolio Service
   */
  HBT_ERR_WORKFLOW_INVALID_PORTFOLIO_STATUS: {
    code: 'HBT_ERR_11000',
    httpCode: HttpResponseStatusCodes.BadRequest,
    message: 'invalid portfolio status'
  },
  HBT_ERR_WORKFLOW_LOANS_IN_REVIEW: {
    code: 'HBT_ERR_11001',
    httpCode: HttpResponseStatusCodes.BadRequest,
    message: 'there are loans in review'
  }
};

export default HbtServiceErrorCodes;
